export default {"src":"/_next/static/media/close.abde109b.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};